import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6b9f6707")

_pushScopeId("data-v-6b9f6707")
const _hoisted_1 = { class: "bulletin-bar" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "bulletin-text" }, [
  /*#__PURE__*/_createVNode("span", null, "关于暂停执行6月20日至7月3日上海浦东至英国伦敦往返国际航班的通告")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})